import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppCircularProgress } from "JS/React/Components/Progress/AppCircularProgress";

const OverlayRoot = styled("div")(({ theme }) => ({
    position: "absolute",
    width: "90%",
    margin: "0 5% 0 5%",
    height: "inherit",
    padding: theme.spacing(1),
    background: theme.palette.common.black,
    opacity: 0.5,
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    transition: "all 0.5s ease",
}));

export const MainPlayerOverlay = (props: MainPlayerOverlayProps) => {
    return (
        <OverlayRoot>
            <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <AppCircularProgress />
            </Box>
        </OverlayRoot>
    );
};

export interface MainPlayerOverlayProps
    extends React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    > {}
